module.exports = __webpack_public_path__ + "img/students.d562ba4f.png";